<template>
  <div :class="[prefix,`${prefix}-wrap`]">
    <div
      v-if="product.Id"
      class="product-item"
      @click="onClick()"
    >
      <div
        class="product-title"
        :title="product.Name"
      >{{product.Name}}</div>
      <div
        class="product-price"
        v-if="!product.IsFaceToPrice"
      >
        <span
          class="price"
          v-if="product.Price"
        ><span class="moneyunit">￥</span>{{product.Price | money }}<span
            v-if="product.Unit"
            class="unit"
          >/</span><span class="unit">{{product.Unit}}</span></span>
      </div>
      <div
        class="product-price"
        v-if="product.IsFaceToPrice"
      >
        <span class="price">待询价</span>
      </div>
      <div class="product-img">
        <img
          :title="product.Name"
          :src="product.PictureUrl"
        >
      </div>
    </div>
  </div>
</template>
<script>
import '@/styles/components/product/simpleProductItem.scss';
const prefix = 'cpt-simple-product-item';
export default {
  props: {
    product: {}
  },
  data () {
    return {
      prefix
    };
  },
  methods: {
    onClick () {
      this.$router.push({ path: '/productDetail', query: { id: this.product.Id } });
    }
  },
  mounted () {
    // console.log(this.product);
  }
};
</script>

<style lang='scss' scoped>
</style>



// WEBPACK FOOTER //
// src/components/product/SimpleProductItem.vue